import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Box, Typography, LinearProgress } from "@material-ui/core";

const KnowledgeSessionCard = ({ data, classes }) => {
  const formatLabel = (sessionType) => {
    if (!sessionType) return "";
    const name =
      sessionType.charAt(0).toUpperCase() +
      sessionType.slice(1).toLowerCase();
    return name.replaceAll("_", " ");
  };

  return (
    <Box className={classes.cardRoot}>
      {data.map((item, index) => {
        const progressValue =
          (item.totalAttendedProgramSession / item.totalProgramSession) * 100;

        return (
          <Box key={index} className={classes.sessionRow}>
            <Box className={classes.labelRow}>
              <Box className={classes.titleContainer}>
                <div className={classes.dot} />
                <Typography className={classes.sessionName}>
                  {formatLabel(item.sessionType)}
                </Typography>
              </Box>
              <Typography className={classes.statsText}>
                {item.totalAttendedProgramSession}/{item.totalProgramSession}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={progressValue}
              classes={{
                root: classes.progressRoot,
                bar: classes.progressBar,
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

const styles = (theme) => ({
  cardRoot: {
    padding: theme.spacing(3),
    fontFamily: "sans-serif",
  },
  header: {
    color: "#757575",
    fontWeight: "bold",
  },
  sessionRow: {
    marginBottom: theme.spacing(3),
  },
  labelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
  },
  dot: {
    width: 10,
    height: 10,
    backgroundColor: "#005696",
    borderRadius: "50%",
    marginRight: theme.spacing(1.5),
  },
  sessionName: {
    color: "#4f5b67",
    fontWeight: 500,
  },
  statsText: {
    color: "#757575",
    fontSize: "0.875rem",
  },
  progressRoot: {
    height: 10,
    borderRadius: 5,
    backgroundColor: "#f0f0f0",
  },
  progressBar: {
    borderRadius: 5,
    backgroundColor: "#f6933e", // The orange from your image
  },
});
export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter
)(KnowledgeSessionCard);
